import React, { Component, Fragment } from 'react';
import styled from '@emotion/styled';

import LinkSection from './LinkSection';
import LinkSectionMobile from './LinkSectionMobile';
import artePropTypes from '../../propTypes';
import { mediaQueries, remCalc } from '../../css';

const StyledSection = styled('ul')(() => ({
    display: 'none',
    [mediaQueries.medium]: {
        display: 'flex',
        margin: 0,
        padding: remCalc(30, 0),
        flexDirection: 'row',
        justifyContent: 'center',
        listStyle: 'none',
    },
}));

const StyledSectionMobile = styled('ul')(() => ({
    margin: 0,
    padding: remCalc(20, 0),
    listStyle: 'none',
    [mediaQueries.medium]: {
        display: 'none',
    },
}));

class MainSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sectionOpen: -1,
        };
    }

    onSectionToggle = index => {
        this.setState({ sectionOpen: index });
    };

    render() {
        const { sections } = this.props;

        return (
            <Fragment>
                <StyledSection>
                    {sections.map((section, index) => (
                        <LinkSection key={`section-${index}`} section={section} />
                    ))}
                </StyledSection>
                <StyledSectionMobile>
                    {sections.map((section, index) => (
                        <LinkSectionMobile
                            key={`mobile-${index}`}
                            onSectionToggle={this.onSectionToggle}
                            section={section}
                            sectionKey={index}
                            sectionOpen={this.state.sectionOpen}
                        />
                    ))}
                </StyledSectionMobile>
            </Fragment>
        );
    }
}

MainSection.propTypes = artePropTypes.mainFooter.isRequired;

MainSection.defaultProps = {
    sections: [],
};

export default MainSection;
